var path = 'batch/metadataRestore/details/metadataRestoreDetails.tpl.html';
var html = "<react-component name='metadata-restore-table' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;